import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { GroupRenewalLoginComponent } from './component/group-renewal-login/group-renewal-login.component';
import { GroupRenewalLandingComponent } from './component/group-renewal-landing/group-renewal-landing.component';
import { HeaderComponent } from './component/header/header.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedAlertModelComponent } from './common-shared-modules/shared-alert-model/shared-alert-model.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { AlertSwipeComponent } from './common-shared-modules/alert-swipe/alert-swipe.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NumberOnlyDirective } from './common-shared-modules/directives/app-directive.directive';
import { CharacterOnlyDirective } from './common-shared-modules/directives/app-directive.directive';
import { PolicyNumberOnlyDirective } from './common-shared-modules/directives/app-directive.directive';
import { AppDirectiveDirective } from './common-shared-modules/directives/app-directive.directive';
import { dateOfBirthOnlyDirective } from './common-shared-modules/directives/app-directive.directive';
import { TruncatePipe } from './common-shared-modules/pipes/truncate.pipe';
import { INRPipe } from './common-shared-modules/pipes/truncate.pipe';
import { UniquePipe } from './common-shared-modules/pipes/truncate.pipe';
import { capitalizePipe } from './common-shared-modules/pipes/truncate.pipe';
import { productFilterPipe } from './common-shared-modules/pipes/truncate.pipe';
import { GroupRenewalPaymentProcessingComponent } from './component/group-renewal-payment-processing/group-renewal-payment-processing.component';
import { GroupRenewalThankYouComponent } from './component/group-renewal-thank-you/group-renewal-thank-you.component';
import { GroupRenewDropoutComponent } from './component/group-renew-dropout/group-renew-dropout.component';
import { GroupRenewalDownloadApiComponent } from './component/group-renewal-download-api/group-renewal-download-api.component';
import { PaymentGatewayComponent } from './common-shared-modules/payment-gateway/payment-gateway.component';


@NgModule({
  declarations: [
    AppComponent,
    GroupRenewalLoginComponent,
    GroupRenewalLandingComponent,
    GroupRenewalLandingComponent,
    HeaderComponent,
    SharedAlertModelComponent,
    AlertSwipeComponent,
    NumberOnlyDirective,
    CharacterOnlyDirective,
    PolicyNumberOnlyDirective,
    AppDirectiveDirective,
    dateOfBirthOnlyDirective,
    TruncatePipe,
    INRPipe,
    UniquePipe,
    capitalizePipe,
    productFilterPipe,
    GroupRenewalPaymentProcessingComponent,
    GroupRenewalThankYouComponent,
    GroupRenewDropoutComponent,
    GroupRenewalDownloadApiComponent,
    PaymentGatewayComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    MatButtonModule,
    MatDialogModule,
    NgxSpinnerModule,
    NgbModule
  ],
  providers: [Title],
  bootstrap: [AppComponent]
})
export class AppModule { }
